/**
 * Shared collision helpers for sim entities that don't have full AntWorld
 * behaviour (spiders, grasshoppers, roly-polies). Circular obstacles are
 * tested one by one — caller batches rocks + grass tufts into the list.
 */

export interface Obstacle {
  x: number;
  z: number;
  radius: number;
}

export interface Body {
  x: number;
  z: number;
  heading: number;
}

/** Push `body` outside of every obstacle it's overlapping after a move.
 *  Reflects the caller's velocity reversal via `heading` flip when blocked. */
export function resolveObstacles(
  body: Body,
  bodyRadius: number,
  obstacles: readonly Obstacle[],
): void {
  for (let i = 0; i < obstacles.length; i++) {
    const o = obstacles[i];
    const dx = body.x - o.x;
    const dz = body.z - o.z;
    const r = o.radius + bodyRadius;
    const d2 = dx * dx + dz * dz;
    if (d2 >= r * r || d2 < 1e-8) continue;
    const d = Math.sqrt(d2);
    body.x = o.x + (dx / d) * r;
    body.z = o.z + (dz / d) * r;
    // Kick heading outward + jitter so the entity doesn't re-enter next frame.
    body.heading = Math.atan2(dz, dx) + (Math.random() - 0.5) * 0.6;
  }
}
